import type * as React from "react";

/** Data table styled from PRDS tokens (leaderboard header row + hover rows). Wrap in a flush Card. */
export function Table({ className = "", ...props }: React.TableHTMLAttributes<HTMLTableElement>) {
  return (
    <div className="pr-tablewrap">
      <table className={["pr-table", className].filter(Boolean).join(" ")} {...props} />
    </div>
  );
}
